import React from 'react';
import { View } from 'react-native';

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import PropTypes from 'prop-types';

import style from './style';

const Separator = () => {
  const theme = useTheme();
  return <View style={style.separator(theme)} />;
};
Separator.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};
export default Separator;
